<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container">
        <a class="navbar-brand icon-img-100" [routerLink] = "'/'">
            <img [src]="logo" alt="Logo" class="logo">
        </a>
        <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNavAltMarkup">
            <ul class="navbar-nav navbar-center xs-mt-20">
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('home')">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('features')">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('services')">Services</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('about')">About</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('pricings')">Pricings</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('contact')">Contact</a>
                </li>
            </ul>
          <div class="nav-button ms-auto xs-ml-0 xs-mt-20">
            <a href="https://play.google.com/store/apps/details?id=com.s1az.s1az_app"
               target="_blank"
               rel="noopener noreferrer"
               class="btn btn-lg btn-gradient-primary btn-circle d-inline-flex align-items-center gap-2">

              <svg width="22" height="22" viewBox="0 0 40 40" aria-hidden="true">
                <path fill="none" d="M0,0h40v40H0V0z"></path>
                <g>
                  <path fill="#EA4335"
                        d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l17.4-9.9L19.7,19.2z"/>
                  <path fill="#FBBC04"
                        d="M35.3,16.4l-7.5-4.3-8.4,7.4 8.5,8.3 7.5-4.2c1.3-0.7 2.2-2.1 2.2-3.6 0-1.5-0.9-2.9-2.2-3.6z"/>
                  <path fill="#4285F4"
                        d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"/>
                  <path fill="#34A853"
                        d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3L19.8,20z"/>
                </g>
              </svg>

              <span>Get it on Google Play</span>
            </a>
          </div>

        </div>

    </div>
</nav>
